
import {Options, prop, Vue} from 'vue-class-component';

    class Props {
      content: any = prop({
        required: false,
      });
    }

    @Options({})
    export default class LinksPanel extends Vue.with(Props) {

        get tiles(): any[] {
            const tiles = this.content && Array.isArray(this.content.tiles)
                ? this.content.tiles.slice()
                : [];

            // randomize tiles
            for (let i = tiles.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [tiles[i], tiles[j]] = [tiles[j], tiles[i]];
            }

            // max 4 tiles
            return tiles.slice(0, 4);
        }
    }
